// Mock personas for content generation
export const prebuiltPersonas = [
  { id: 'ceo', name: 'Professional CEO', tone: 'Authoritative, strategic, data-driven', emoji: '👔' },
  { id: 'blogger', name: 'Casual Blogger', tone: 'Friendly, conversational, relatable', emoji: '✍️' },
  { id: 'techexpert', name: 'Tech Expert', tone: 'Technical, precise, innovative', emoji: '💻' },
  { id: 'marketer', name: 'Marketing Guru', tone: 'Persuasive, creative, trend-focused', emoji: '📊' },
  { id: 'educator', name: 'Educator', tone: 'Clear, patient, informative', emoji: '🎓' },
  { id: 'entrepreneur', name: 'Entrepreneur', tone: 'Bold, inspirational, action-oriented', emoji: '🚀' },
  { id: 'journalist', name: 'Journalist', tone: 'Objective, investigative, factual', emoji: '📰' },
  { id: 'consultant', name: 'Business Consultant', tone: 'Advisory, analytical, solution-focused', emoji: '💼' },
  { id: 'coach', name: 'Life Coach', tone: 'Motivational, empowering, supportive', emoji: '🌟' },
  { id: 'analyst', name: 'Data Analyst', tone: 'Analytical, methodical, insights-driven', emoji: '📈' },
  { id: 'creative', name: 'Creative Director', tone: 'Artistic, bold, visionary', emoji: '🎨' },
  { id: 'scientist', name: 'Scientist', tone: 'Research-based, logical, evidence-driven', emoji: '🔬' }
];

// Mock trending topics from Google
export const mockTrendingTopics = [
  { query: 'AI automation 2025', volume: '50K', trend: '+125%', category: 'Technology' },
  { query: 'Remote work productivity', volume: '35K', trend: '+89%', category: 'Business' },
  { query: 'Sustainable business practices', volume: '28K', trend: '+67%', category: 'Sustainability' },
  { query: 'Digital marketing trends', volume: '45K', trend: '+103%', category: 'Marketing' },
  { query: 'Cybersecurity best practices', volume: '32K', trend: '+78%', category: 'Security' },
  { query: 'E-commerce optimization', volume: '41K', trend: '+95%', category: 'Business' },
  { query: 'AI content creation', volume: '38K', trend: '+112%', category: 'Technology' },
  { query: 'Customer experience design', volume: '29K', trend: '+71%', category: 'UX' }
];

// Mock Google search data
export const mockSearchData = {
  relatedQuestions: [
    'What are the benefits of AI automation for small businesses?',
    'How can AI improve business productivity?',
    'What are the best AI tools for content creation?',
    'How to implement AI in your workflow?'
  ],
  topResults: [
    { title: 'AI Automation Trends 2025', source: 'TechCrunch', snippet: 'Latest developments in AI automation...' },
    { title: 'Business Automation Guide', source: 'Forbes', snippet: 'Complete guide to automating business processes...' },
    { title: 'AI Tools Comparison', source: 'Business Insider', snippet: 'Comparing top AI platforms...' }
  ],
  statistics: [
    '87% of businesses report increased efficiency with AI',
    'AI automation market to reach $15.7B by 2027',
    '64% of companies use AI for content generation'
  ]
};